import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import {
  shallowEqual, useDispatch, useSelector
} from 'react-redux';
import { Link, useOutletContext } from 'react-router-dom';
import { withLang } from '../../../i18n';
import surveyStyles from '../survey.module.css';
import styles from './researchConsent.module.css';
import { updateResearchConsentAction } from '../../../actions';
import { routes } from '../../../constants';
import TranslatedHTMLText from '../../TranslatedHTMLText';
import SurveyProgressBar from '../SurveyProgressBar';
import SubmitSurveyButton from '../SubmitSurveyButton';
import { autoFocusElementById, getCompiledPath, getSurveySchemaPartAmount } from '../../../util';

const RESEARCH_CONSENT_GIVEN = 'research_consent_given';
const RESEARCH_CONSENT_TITLE_ID = 'research_consent_title';

const ResearchConsent = (props) => {
  const {
    lang, translate
  } = props;

  const {
    survey, researchConsentGiven
  } = useSelector(
    (state) => ({
      survey: state.survey.surveyContent,
      researchConsentGiven: state.survey.researchConsentGiven
    }), {
      equalityFn: shallowEqual
    }
  );

  const dispatch = useDispatch();
  const schemaPartAmount = getSurveySchemaPartAmount(survey);
  const pageNumber = schemaPartAmount + 1;
  const [setCurrentPage, setPageCount] = useOutletContext();

  useEffect(() => {
    autoFocusElementById(RESEARCH_CONSENT_TITLE_ID, 0);
  }, []);

  const onResearchConsentChange = useCallback(
    (e) => dispatch(updateResearchConsentAction(e.target.checked)),
    []
  );

  const renderTitle = () => (
    <div className="flex-inline">
      <h2 id={RESEARCH_CONSENT_TITLE_ID} className="panel__title">{translate('survey.researchConsentTitle')}</h2>
    </div>
  );

  const renderResearchConsent = useCallback(
    () => (
      <div className={styles.researchConsentContainer}>
        <div className="form__item">
          <input
            type="checkbox"
            id={RESEARCH_CONSENT_GIVEN}
            checked={researchConsentGiven}
            onChange={onResearchConsentChange}
          />
          <label className={styles.label} htmlFor={RESEARCH_CONSENT_GIVEN}><Translate id="survey.researchConsent" /></label>
        </div>
        {/* WARNING: UH-670 - Might not be accessible if the html is not formatted correctly */}
        <TranslatedHTMLText html={survey.researchAgreement} inLanguage={lang} />
      </div>
    ),
    [lang, translate, survey, researchConsentGiven]
  );

  return (
    <section className="fastFadeIn">
      <SurveyProgressBar
        current={pageNumber}
        total={schemaPartAmount}
        researchConsentNeeded={survey.researchConsentNeeded}
        setCurrentPage={setCurrentPage}
        setPageCount={setPageCount}
      />
      {renderTitle()}
      {renderResearchConsent()}
      <nav className={surveyStyles.navigation}>
        <Link
          className={`${surveyStyles.navButton} button--action icon--arrow-left`}
          to={getCompiledPath(routes.survey.surveyPart, { surveyId: survey.id, page: schemaPartAmount })}
        >
          <Translate id="common.previous" />
        </Link>
        <SubmitSurveyButton canSubmit={() => true} />
      </nav>
    </section>
  );
};

const { func, string } = PropTypes;
ResearchConsent.propTypes = {
  lang: string.isRequired,
  translate: func.isRequired
};

export default withLang(ResearchConsent);
